<template>
  <div class="pub_header">
    <div class="container1 header">
      <div class="map" @mouseenter="showMapList = true" @mouseleave="showMapList = false">
        <i class="el-icon-location-outline"></i>
        <span class="city">{{ localCityName }}</span>
        <span class="com_link">{切换}</span>
        <div class="list" v-show="showMapList">
          <div class="list_header"></div>
          <div class="content">
            <span v-for="(v,i) in cityList" :key="i" @click="onChangeCity(v)">{{v.name}}</span>
          </div>
        </div>
      </div>

      <ul class="my_center">
        <li class="name" v-if="isLogin">{{ userName }}</li>

        <li v-if="isLogin" @click="loginOut">退出</li>

        <li v-if="!isLogin">
          <a href="/login" @click.prevent="goWithRedirect($route.fullPath)">登录</a>
        </li>

        <li v-if="!isLogin">
          <a href="/register" @click.prevent="goWithRedirect($route.fullPath,true)">注册</a>
        </li>

        <li @click="goRequirePage('/personalCenter/myOrder')">个人中心</li>

        <li v-if="userType === 2" @click="goDuobi">商家中心</li>

        <li @click="showDialog = true">扫码关注</li>

        <li v-if="$route.path!=='/home'">
          <a href="/" target="_blank">返回首页</a>
        </li>
      </ul>
    </div>

    <el-dialog title="关注多比公众号" :visible.sync="showDialog" width="300px">
      <div class="img">
        <img :src="require('@/assets/img/qrCode3.jpg')" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { setLoginOut } from "@/pages/publicUtils/setLogin";
import { GetNewProvinceList } from "@/pages/page1/api/modules/common";
import getCurrentCityName from "@/pages/publicUtils/getCurrentCityName";
export default {
  name: "publicHeader",
  data() {
    return {
      userName: "",
      isLogin: false,

      localCityName: "",
      localCityCode: "",
      cityList: [],
      showMapList: false,

      showDialog: false,
      userType: undefined,
    };
  },
  mounted() {
    this.getUserName();
    getCurrentCityName().then((res) => {
      this.localCityName = res;
    });
    this.getNewProvinceList();
  },
  methods: {
    getUserName() {
      if (!this.$cookies.isKey("ACCESS_TOKEN")) {
        this.isLogin = false;
        return;
      }
      this.isLogin = true;
      let userInfo = this.$store.state.userInfo;
      this.userType = userInfo.userType;
      // console.log(this.userType);
      if (userInfo.mobile) {
        userInfo.mobile = userInfo.mobile.replace(
          /^(\d{3})\d{4}(\d+)/,
          "$1****$2"
        );
      }
      if (userInfo.userType == 3) {
        this.userName =
          userInfo.nickName || userInfo.mobile || userInfo.userName || "";
      } else {
        this.userName = userInfo.userName || "";
      }
    },
    getNewProvinceList() {
      GetNewProvinceList().then((res) => {
        // console.log("地址列表", res);
        this.cityList = res.data;
      });
    },
    onChangeCity(v) {
      // console.log(v);
      this.localCityName = v.name;
      this.localCityCode = v.code;
      this.showMapList = false;
      localStorage.setItem("_localCity", v.name);
    },
    // 去需要登录的页面
    goRequirePage(path) {
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        let newUrl = this.$router.resolve(path);
        window.open(newUrl.href, "_blank");
      } else {
        this.goWithRedirect(path);
      }
    },
    loginOut() {
      setLoginOut();
      this.goWithRedirect(this.$route.fullPath);
    },
    // 去登录页 或者注册页带重定向地址
    goWithRedirect(path, register) {
      let newUrl = this.$router.resolve({
        path: register ? "/register" : "/login",
        query: {
          redirect: path,
        },
      });
      window.open(newUrl.href, "_self");
    },
    // 去平台
    goDuobi() {
      let newUrl = this.$router.resolve("/duobi");
      window.open(newUrl.href, "_blank");
    },
  },
  // 监听路由变化
  // watch: {
  // $route: {
  //   handler(newRouter) {
  //     console.log(newRouter);
  //     if (newRouter.path === "/") {
  //       this.isHome = true;
  //     } else {
  //       this.isHome = false;
  //     }
  //   },
  //   immediate: true,
  // },
  // },
};
</script>

<style scoped lang="less">
.pub_header {
  width: 100%;
  min-width: @themeWidth;
  height: 30px;
  line-height: 30px;
  background: #f6f6f6;
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  .header {
    position: relative;
    display: flex;
    .map {
      margin-right: 108px;
      position: relative;
      i {
        font-weight: bold;
      }
      .city {
        padding: 0 14px 0 6px;
      }
      .list {
        position: absolute;
        left: 0;
        top: 100%;
        width: 214px;
        height: 144px;
        background: #ffffff;
        z-index: 1996;
        .list_header {
          height: 10px;
          position: relative;
          &::before {
            display: block;
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            left: 72px;
            bottom: 0px;
            border-width: 10px;
            border-style: solid;
            border-color: transparent transparent #cbcbcb transparent;
          }
          &::after {
            display: block;
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            left: 72px;
            bottom: -2px;
            border-width: 10px;
            border-style: solid;
            border-color: transparent transparent #ffffff transparent;
          }
        }
        .content {
          height: calc(100% - 10px);
          box-sizing: border-box;
          padding: 4px 20px;
          padding-left: 8px;
          border: 1px solid #cbcbcb;
          border-radius: 6px;
          display: flex;
          flex-wrap: wrap;
          overflow: auto;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          span {
            margin-left: 12px;
            display: inline-block;
            cursor: pointer;
            &:hover {
              color: @themeColor;
            }
          }
        }
      }
    }
    .my_center {
      position: absolute;
      top: 0;
      right: 0;
      li {
        display: inline-block;
        color: #333333;
        margin-left: 24px;
        cursor: pointer;
        &:hover {
          color: @themeColor;
        }
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-left: 32px;
        }
        a {
          color: #333333;
        }
      }
      .name {
        color: @themeColor;
      }
    }
  }
}
</style>